import React from "react";
import DateHelper from "../../DateHelper/DateHelper";

export default class ReservationCardRecipients extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      emailLogEventsVisible: {}
    };
    this.onToggleEmailLogEvents = this.onToggleEmailLogEvents.bind(this);
  }
  /**
  * Render functions
  */

  render() {
    var self = this;

    return(
      <div>
        {self.props.email.recipients && self.props.email.recipients.length > 0 ?
          <div className="panel-group" style={{marginBottom: 0}}>
            {self.renderRecipients()}
          </div> :
          <em>{I18n.t('not_yet')}</em>
        }
      </div>
    )
  }

  renderEmailLogEvents(recipient) {
    var self = this;
    var emailLogEvents = []

    recipient.email_log_events.map(function(ele) {
      emailLogEvents.push(
        <tr key={ele.id} className="email-log-event">
          <td><span style={{color: '#7F7F7F'}} className='ss-help' title={I18n.t('email_log_event_helper_text')}></span> <span title={ele.message}>{I18n.t(ele.event_name)}</span></td>
          <td>{DateHelper.printDateToScreen(ele.event_date, self.props.date_format)} {I18n.t('at')} {DateHelper.printDateToScreen(ele.event_date, self.props.time_format)}</td>
        </tr>
      )
    })
    return(
      <tbody className="email-log-events">
        {emailLogEvents}
      </tbody>
    )
  }

  renderRecipients() {
    var self = this;
    var recipients = [];

    self.props.email.recipients.map(function(recipient) {
      var firstEvent = recipient.email_log_events[0];
      if (firstEvent) {
        recipients.push(
          <div key={recipient.id} className={"panel panel-default recipients-" + (self.props.size || 'default')}>
            <div className="panel-heading" role="tab">
              <h6 className="panel-title" style={{fontSize: '14px', marginBottom: 0}}>
                <a className="collapsed" onClick={self.onToggleEmailLogEvents.bind(null, recipient)} style={{cursor: 'pointer'}}>
                  <div className="container clearfix">
                    <strong className="row pull-left">
                      <div className="col-sm-9">
                        <div className={"toggle-arrow " + (self.emailLogEventsVisible(recipient) ? 'arrow-down' : 'arrow-right')}>&nbsp;</div>
                        {recipient.name ? recipient.name : recipient.email_log_events.length == 1 ? recipient.email_log_events[0].message : null}
                      </div>
                      <div className="col-sm-3 row">
                        <div style={{ color: 'black' }}>{I18n.t("status") + ":"}</div>
                        {
                        firstEvent.event_name == "failed"
                        ?
                        <div style={{ color: 'red' }}>{I18n.t(firstEvent.event_name)}</div>
                        : 
                        firstEvent.event_name == "delivered" || firstEvent.event_name == "opened" || firstEvent.event_name == "clicked"
                        ?
                        <div style={{ color: 'green' }}>{I18n.t(firstEvent.event_name)}</div>
                        : 
                        <div style={{ color: 'black' }}>{I18n.t(firstEvent.event_name)}</div>
                        }
                      </div>
                    </strong>
                  </div>
                </a>
              </h6>
            </div>
            <div className="panel-body" style={{padding: '0 10px 5px 10px', marginTop: '10px', display: (self.emailLogEventsVisible(recipient) ? 'block' : 'none')}}>
              <table className="table table-inset">
                {self.renderEmailLogEvents(recipient)}
              </table>
            </div>
          </div>
        );
      }
    });

    return (
      <div className="recipients">
        {recipients}
      </div>
    );
  }

  /**
  * Event handlers
  */ 

  onToggleEmailLogEvents(recipient, event) {
    event.stopPropagation();
    event.preventDefault();

    if (this.state.emailLogEventsVisible[recipient.id]) {
      delete this.state.emailLogEventsVisible[recipient.id];
      this.setState({emailLogEventsVisible: this.state.emailLogEventsVisible});
    } else {
      this.state.emailLogEventsVisible[recipient.id] = true;
      this.setState({emailLogEventsVisible: this.state.emailLogEventsVisible});
    }
  }

  /**
  * Helper functions
  */

  emailLogEventsVisible(recipient) {
    if (this.state.emailLogEventsVisible[recipient.id]) {
      return true;
    } else {
      return false;
    }
  }

}